var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(`v-${_vm.type}`,_vm._b({tag:"component",attrs:{"error-messages":_vm.field.errorMessages,"success-messages":_vm.field.successMessages},on:{"change":function($event){_vm.validate;
    _vm.emit;}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'component',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }